import React from "react"
import { TableColumn } from "resha"
import { AsyncBinaryChoice } from "../../../../../Common/AsyncBinaryChoice/AsyncBinaryChoice"
import { SuperAILabelerModel } from "../../../../../../Models/Client/SuperAILabelerModel"
import { fromNow } from "../../../../../../Helpers/Functions/dateFormat"
import { NoData } from "../../../../../Common/NoData/NoData"

export const superAILabelerColumns: (args: {
    handleToggleActive?: (id: string, isActive: boolean) => Promise<void>
}) => TableColumn<SuperAILabelerModel>[] = ({ handleToggleActive }) => {
    const columns: TableColumn<SuperAILabelerModel>[] = [
        {
            className: "truncate font-semibold",
            renderHeader: () => "Email",
            render: ({ email, isActive }) => (
                <>
                    <span className={isActive ? "" : "line-through"}>
                        {email}
                    </span>
                </>
            )
        },
        {
            className: "text-smoke-610",
            renderHeader: () => "Tasks completed",
            render: ({ taskCompleted }) => taskCompleted.toLocaleString()
        },
        {
            className: "text-smoke-610",
            renderHeader: () => "Task time (median)",
            render: ({ taskMedianTime }) => {
                if (taskMedianTime > 120) {
                    return `${Math.round(
                        taskMedianTime / 60
                    ).toLocaleString()} mins`
                }

                return `${taskMedianTime.toLocaleString()} secs`
            }
        },
        {
            className: "text-smoke-610",
            renderHeader: () => "Reviewed as correct",
            render: ({ reviewScore, reviewedCount }) =>
                reviewScore === undefined || reviewedCount === undefined ? (
                    <NoData />
                ) : (
                    `${(reviewScore * 100).toPrecision(
                        3
                    )}% (of ${reviewedCount.toLocaleString()})`
                )
        },
        {
            className: "text-smoke-610",
            renderHeader: () => "Last processed",
            render: ({ lastLabeled, taskCompleted }) =>
                taskCompleted === 0
                    ? "Never"
                    : fromNow(new Date(lastLabeled)).replace(/minute/, "min")
        }
    ]

    return columns.concat([
        {
            className: "text-smoke-610",
            renderHeader: () => "Trust score",
            render: ({ trustScore }) =>
                trustScore === undefined ? (
                    <NoData />
                ) : (
                    String(trustScore.toPrecision(3))
                )
        },
        {
            className: "my-1",
            renderHeader: () => <div className="text-right">Activated</div>,
            render: model => (
                <div className="flex justify-end">
                    <AsyncBinaryChoice
                        testId="toggle-activeness"
                        interactive={true}
                        isChecked={model.isActive}
                        onChange={
                            handleToggleActive === undefined
                                ? undefined
                                : () =>
                                      handleToggleActive(
                                          model.uuid,
                                          !model.isActive
                                      )
                        }
                        className="mr-0"
                        buttonColor="violet"
                        size="xs"
                        disabled={handleToggleActive === undefined}
                    />
                </div>
            )
        }
    ])
}
